import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { BsGithub } from 'react-icons/bs';
import './header.css';

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://github.com/Adan-Perez" target="_blank" rel="noreferrer">
        <BsGithub />
      </a>
      <a href="https://www.linkedin.com/in/adan-perez-rodriguez-6b6756256/" target="_blank" 
      rel="noreferrer"
      >
        <BsLinkedin />
      </a>
    </div>
  );
};

export default HeaderSocials;
